import './style.css';
import { renderHeader } from './components/Header.js';
import { renderHero } from './components/Hero.js';
import { renderAbout } from './components/About.js';
import { renderMarquee } from './components/Marquee.js';
import { renderCapabilities } from './components/Capabilities.js';
import { renderPerspective } from './components/Perspective.js';
import { renderSelectedWorks } from './components/SelectedWorks.js';
import { renderCurrentlyBuilding } from './components/CurrentlyBuilding.js';
import { renderInquiryTerminal, initInquiryTerminal } from './components/InquiryTerminal.js';
import { HeroScene } from './three/HeroScene.js';

document.addEventListener('DOMContentLoaded', () => {
  // 1. Mount Global Components
  const headerRoot = document.getElementById('site-header-root');
  if (headerRoot) headerRoot.innerHTML = renderHeader();

  const appRoot = document.getElementById('app');
  if (appRoot) {
    appRoot.innerHTML = `
      ${renderHero()}
      ${renderAbout()}
      ${renderMarquee()}
      ${renderCapabilities()}
      ${renderPerspective()}
      ${renderSelectedWorks()}
      ${renderCurrentlyBuilding()}
    `;
  }

  const footerRoot = document.getElementById('site-footer-root');
  if (footerRoot) {
    footerRoot.innerHTML = renderInquiryTerminal();
    initInquiryTerminal();
  }

  // 2. Initialize Three.js Hero 3D Scene
  const heroContainer = document.getElementById('three-hero-container');
  let heroScene = null;
  if (heroContainer) {
    heroScene = new HeroScene(heroContainer);
  }

  // 3. Coordinate Telemetry & Interactive Flourishes
  window.addEventListener('beforeunload', () => {
    if (heroScene) heroScene.destroy();
  });

  // Developer signature in console
  console.log(
    "%c RANJIKA NETHPRIYA %c Ideas into Systems // 2026 ",
    "background: #050505; color: #FAF8F5; font-weight: 700; padding: 4px 8px; border: 1px solid #1C201E;",
    "background: #38BDF8; color: #050505; font-weight: 700; padding: 4px 8px;"
  );
});
